import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BiSearch } from "react-icons/bi";
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import Footer from './Footer';
import postlist from '../posts.json';

const Artistas = () => {
  const [categorias, setCategorias] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Todas las categorías');
  const [terminoBusqueda, setTerminoBusqueda] = useState('');

  useEffect(() => {
    // Obtener todas las categorías únicas de los posts
    const uniqueCategorias = [...new Set(postlist.flatMap((post) => post.categories.split(',').map(c => c.trim())))];

    // Agregar una opción predeterminada al principio del array
    uniqueCategorias.unshift('Todas las categorías');

    // Establecer las categorías en el estado
    setCategorias(uniqueCategorias);

    // Ajusta la posición de la ventana al principio de la carga
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Desplazarse a la parte superior cuando cambie la categoría seleccionada
    window.scrollTo(0, 0);
  }, [categoriaSeleccionada]);

  const handleCategoriaChange = (e) => {
    setCategoriaSeleccionada(e.target.value);
  };

  const artistasFiltrados = postlist.filter((post) =>
    (categoriaSeleccionada === 'Todas las categorías' || post.categories.split(',').map(c => c.trim()).includes(categoriaSeleccionada)) &&
    (terminoBusqueda === '' || post.title.toLowerCase().includes(terminoBusqueda.toLowerCase()))
  );

  return (
    <div id='artistas'>
      <section  className='container mx-auto sm:pt-5 lg:pt-14 pb-10'>
        <motion.div
          variants={fadeIn('up', 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.3 }}
          className='flex-1 flex flex-col gap-y-5'>

          <div className='mx-auto flex flex-col md:flex-row justify-center items-center gap-8 pb-14'>
            <label className="relative block w-full">
              <span className="sr-only">Search</span>
              <span className="absolute inset-y-0  flex items-center px-4">
                <svg className="h-7 w-7 text-black" viewBox="0 0 20 20"><BiSearch /></svg>
              </span>
              <input
                className="btn btn-sm placeholder:text-primary text-[20px] pl-14 w-80"
                placeholder="Buscar artista favorito"
                type="text"
                name="search"
                value={terminoBusqueda}
                onChange={(e) => setTerminoBusqueda(e.target.value)}
              />

            </label>

            <label className="relative block w-full">
              <span className="sr-only">Search categories</span>
              <select
                className="btn btn-sm text-primary text-[20px] w-80"
                name="categorias"
                value={categoriaSeleccionada}
                onChange={handleCategoriaChange}
              >
                {categorias.map((categoria, index) => (
                  <option key={index} value={categoria}>
                    {categoria}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </motion.div>

        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8'>
          {artistasFiltrados.map((post, i) => {
            return (
              <motion.div
                key={i}
                variants={fadeIn('up', 0.3)}
                initial="hidden"
                whileInView={"show"}
                viewport={{ once: false, amount: 0.3 }}
                className='flex-1 flex flex-col lg:mb-0'>
                <Link className="links" to={`/artistas/${post.id}`}>
                  <div className='card border-2 border-white/20 rounded-xl relative'>
                    <img
                      src={`/ImgArtistas/${post.image}`}
                      alt={post.title}
                      className='object-cover rounded-xl w-full h-[200px] lg:h-[300px] xl:h-[400px]'
                    />
                    <div className='absolute bottom-0 left-0 right-0 bg-black/50 p-2 text-center text-white text-lg rounded-xl'>
                      {post.title}
                    </div>
                  </div>
                </Link>
              </motion.div>
            )
          })}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Artistas;
